module.exports = __webpack_public_path__ + "static/img/planRightOne.21013ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/planRightOne.png
// module id = vWFk
// module chunks = 2